<div class="welcome-container">
  <img src="arihantLogo.png" alt="Logo" class="logo">
  <h2>Welcome, {{ userInfo?.username }}!</h2>
</div>
<div class="container mt-4" *ngIf="(canViewInvoice || canViewSticker || canViewTC || canViewOperations)">
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h4 class="mb-0">Work Orders</h4>
    <span class="badge bg-primary fs-10 px-3 py-2">
      Pending Work Orders: {{ pendingCount }}
    </span>
  </div>

  <table class="table table-bordered table-striped table-sm">
    <thead class="table-light">
      <tr>
        <th>WO #</th>
        <th>PO #</th>
        <th>Company</th>
        <th *ngIf="canViewInvoice">Invoice</th>
        <th *ngIf="canViewSticker">Sticker</th>
        <th *ngIf="canViewTC">TC</th>
        <th *ngIf="canViewOperations">Operations</th>
        <th *ngIf="canViewOperations">Actions</th>
      </tr>
      <tr>
        <th>
          <input type="text" class="form-control" placeholder="Search WO #" [(ngModel)]="filter.woId"
            (input)="applyFilters()" />
        </th>
        <th>
          <input type="text" class="form-control" placeholder="Search PO #" [(ngModel)]="filter.poId"
            (input)="applyFilters()" />
        </th>
        <th>
          <input type="text" class="form-control" placeholder="Search Company" [(ngModel)]="filter.workOrderCompany"
            (input)="applyFilters()" />
        </th>
        <th *ngIf="canViewInvoice">
          <select class="form-select" [(ngModel)]="filter.invoiceStatus" (change)="applyFilters()">
            <option value="Pending">Pending</option>
            <option value="Done">Done</option>
            <option value="">All</option>
          </select>
        </th>
        <th *ngIf="canViewSticker">
          <select class="form-select" [(ngModel)]="filter.stickerStatus" (change)="applyFilters()">
            <option value="Pending">Pending</option>
            <option value="Done">Done</option>
            <option value="">All</option>
          </select>
        </th>
        <th *ngIf="canViewTC">
          <select class="form-select" [(ngModel)]="filter.tcStatus" (change)="applyFilters()">
            <option value="Pending">Pending</option>
            <option value="Done">Done</option>
            <option value="">All</option>
          </select>
        </th>
        <th *ngIf="canViewOperations">
          <select class="form-select" [(ngModel)]="filter.operationsStatus" (change)="applyFilters()">
            <option value="Pending">Pending</option>
            <option value="Done">Done</option>
            <option value="">All</option>
          </select>
        </th>
        <th>
          <button (click)="resetFilters()" class="btn btn-sm text-primary">
            <i class="fa fa-x" aria-hidden="true"></i>
          </button>
        </th>
      </tr>

    </thead>
    <tbody>
      <tr *ngFor="let wo of filteredPendingWorkOrders">
        <td>{{ wo.workOrderNumber }}</td>
        <td>{{ wo.purchaseOrderNumber }}</td>
        <td>
          <i class="fa"
            [ngClass]="revealedCompanies.has(wo.workOrderId) ? 'fa-eye-slash text-danger' : 'fa-eye text-primary'"
            style="cursor: pointer; margin-right: 5px;" (click)="toggleCompanyVisibility(wo.workOrderId)">
          </i>
          <span>
            {{ revealedCompanies.has(wo.workOrderId)
            ? (workOrderCommonServices.getClientName(wo.workOrderCompanyId)?.companyName || '-')
            : '••••••••' }}
          </span>
        </td>

        <td *ngIf="canViewInvoice">
          <span class="badge" [ngClass]="wo.invoiceUpdatedBy ? 'bg-success' : 'bg-warning text-dark'">
            {{ wo.invoiceUpdatedBy ? 'Done' : 'Pending' }}
          </span>
        </td>

        <td *ngIf="canViewSticker">
          <span class="badge" [ngClass]="wo.stickerUpdatedBy ? 'bg-success' : 'bg-warning text-dark'">
            {{ wo.stickerUpdatedBy ? 'Done' : 'Pending' }}
          </span>
        </td>

        <td *ngIf="canViewTC">
          <span class="badge" [ngClass]="wo.tcUpdatedBy ? 'bg-success' : 'bg-warning text-dark'">
            {{ wo.tcUpdatedBy ? 'Done' : 'Pending' }}
          </span>
        </td>

        <td *ngIf="canViewOperations">
          <span class="badge" [ngClass]="wo.operationsUpdatedBy ? 'bg-success' : 'bg-warning text-dark'">
            {{ wo.operationsUpdatedBy ? 'Done' : 'Pending' }}
          </span>
        </td>
        <td>
          <button class="btn btn-primary btn-sm" (click)="navigateToWorkOrder(wo.workOrderNumber)"
           title="View">
            <i class="fa fa-edit" aria-hidden="true"></i>
          </button>
          <button class="btn btn-primary btn-sm" (click)="generateInvoice(wo.workOrderId)"
           title="View">
            <i class="fa fa-eye"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
